import axios from "axios";
import { loadStripe } from "@stripe/stripe-js";
import { API_BASE_URL, STRIPE_PUBLISHABLE_KEY } from "../config/config";

export const redirectToStripeCheckout = async (service) => {
  if (!service?._id || !service?.currency || service?.careFees == null) {
    throw new Error("Selected service is missing payment details.");
  }

  const response = await axios.post(`${API_BASE_URL}/create-checkout-session`, {
    currency: service.currency,
    careFees: service.careFees,
    userId: service._id,
  });

  const stripe = await loadStripe(STRIPE_PUBLISHABLE_KEY);
  const { error } = await stripe.redirectToCheckout({
    sessionId: response.data.id,
  });

  if (error) {
    throw error;
  }
};
